export default __webpack_public_path__ + "static/media/avatar_grumpy_cat6.ad21f5e6.mp3";